import React from 'react';
import { motion } from 'framer-motion';

export default function SectionTitle({ code, title, subtitle, align = 'left' }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7 }}
      className={align === 'center' ? 'text-center' : ''}
    >
      <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`}>
        <div className="w-10 h-px bg-cyan-400" />
        <span className="text-[10px] font-mono tracking-[0.4em] text-cyan-300">{code}</span>
        <div className="w-2 h-2 bg-cyan-400 blink" />
      </div>
      <h2 className="font-display text-4xl md:text-6xl font-bold text-white mt-4 tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-3 text-slate-400 max-w-2xl ${align === 'center' ? 'mx-auto' : ''}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
